const SelectedBidStatus = {
    Unselected: 'unselected',
    New: 'new',
    Selected: 'selected',
}

export default SelectedBidStatus;